var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 100,
    viewBox: "0 0 124 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 100H0V0H124V100ZM3.99125 96.0085H120.009V3.99147H3.99125V96.0085Z",
    fill: "#FD5956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0037 52.0054H8.00187V8.00233H78.0037V52.0054ZM11.9931 47.9946H73.9931V11.9938H11.9931V47.9946Z",
    fill: "#FD5956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 8.00233H81.995V11.9938H115.998V8.00233Z",
    fill: "#FD5956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 16.0047H81.995V19.9961H115.998V16.0047Z",
    fill: "#FD5956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 24.007H81.995V27.9984H115.998V24.007Z",
    fill: "#FD5956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 32.0093H81.995V36.0008H115.998V32.0093Z",
    fill: "#FD5956"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 40.0116H81.995V44.0031H115.998V40.0116Z",
    fill: "#FD5956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 47.9946H81.995V51.986H115.998V47.9946Z",
    fill: "#FD5956"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.005 91.9977H8.00187V55.9969H42.005V91.9977ZM11.9931 88.0062H37.9944V60.0659H11.9931V88.0062Z",
    fill: "#FD5956"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0037 91.9977H45.9963V55.9969H78.0037V91.9977ZM50.0069 88.0062H73.9931V60.0659H50.0069V88.0062Z",
    fill: "#FD5956"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M115.998 91.9977H81.995V55.9969H115.998V91.9977ZM86.0056 88.0062H112.007V60.0659H86.0056V88.0062Z",
    fill: "#FD5956"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.005 44.0031C39.2345 44.0031 36.5261 43.1815 34.2225 41.6422C31.9189 40.1029 30.1234 37.915 29.0632 35.3552C28.0029 32.7954 27.7255 29.9786 28.266 27.2612C28.8065 24.5437 30.1407 22.0476 32.0998 20.0884C34.0588 18.1292 36.5548 16.795 39.2722 16.2545C41.9895 15.7139 44.806 15.9913 47.3657 17.0516C49.9253 18.1119 52.1131 19.9075 53.6523 22.2113C55.1916 24.515 56.0131 27.2235 56.0131 29.9942C56.0131 33.7096 54.5373 37.2728 51.9102 39.9C49.2832 42.5272 45.7202 44.0031 42.005 44.0031ZM42.005 19.9961C40.0277 19.9961 38.0948 20.5825 36.4507 21.6811C34.8066 22.7797 33.5252 24.3412 32.7685 26.1681C32.0118 27.995 31.8138 30.0053 32.1996 31.9447C32.5854 33.8841 33.5375 35.6656 34.9357 37.0639C36.3339 38.4621 38.1153 39.4144 40.0546 39.8001C41.9939 40.1859 44.0041 39.9879 45.8309 39.2312C47.6577 38.4745 49.2191 37.193 50.3176 35.5488C51.4162 33.9046 52.0025 31.9716 52.0025 29.9942C51.9974 27.3441 50.9424 24.804 49.0686 22.9301C47.1949 21.0563 44.6549 20.0012 42.005 19.9961Z",
    fill: "#FD5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.75114a8c7c2ff720854e64ae31bd0d40.svg";
export { ForwardRef as ReactComponent };